import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import InventoryComp  from "./Component/InventoryComp"

const Inventory =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <InventoryComp />
        </div>
        <Footer />
        </>
    )
}

export default Inventory